module.exports = __webpack_public_path__ + "img/seller_add post cropped.c85bc880.svg";